import React from "react";
import { EditableDropdownProps } from "../types/PriceTabTypes";

export const EditableDropdownCell: React.FC<EditableDropdownProps> = ({
  value,
  options,
  onChange,
  disabled = false,
  isLoading = false
}) => {
  const dropdownId = React.useMemo(() => Math.random().toString(36), []);

  return (
    <div className="dropdown-cell">
      <select
        id={dropdownId}
        className="form-select form-select-sm"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || isLoading}
        style={{ minWidth: '120px' }}
      >
        <option value="">Select Tax...</option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.label}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};